var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{staticStyle:{"height":"400px"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',{staticClass:"headline text--secondary"},[_vm._v("Pagina no encontrada")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }